import apiClient from './apiClient';
import {
  TalkPlanMasterCreateRequest,
  TalkPlanMasterCreateResponse,
  TalkPlanMasterDetailResponse,
  TalkPlanMasterListResponse,
  TalkPlanMasterUpdateRequest,
  TalkPlanMasterUpdateResponse
} from '../types/talkPlanMaster';

/**
 * 対話プランマスター一覧を取得
 */
export const getTalkPlanMasters = async(params: {
  page?: number;
  page_size?: number;
  ordering?: string;
} = {}) => {
  const response = await apiClient.get<TalkPlanMasterListResponse>('/external/talk_plan_masters/', {
    params
  });
  return response.data;
};
/**
 * 対話プランマスター詳細を取得
 */
export const getTalkPlanMaster = async(id: number) => {
  const response = await apiClient.get(`/external/talk_plan_masters/${id}/`);
  return response.data;
};
/**
 * 対話プランマスター詳細を取得（看護師一覧を含む）
 */
export const getTalkPlanMasterDetail = async(id: number, params: {
  nurses_page?: number;
  nurses_page_size?: number;
} = {}): Promise<TalkPlanMasterDetailResponse> => {
  const response = await apiClient.get<TalkPlanMasterDetailResponse>(`/external/talk_plan_masters/${id}/`, {
    params
  });
  return response.data;
};
/**
 * 対話プランマスターを作成
 */
export const createTalkPlanMaster = async(data: TalkPlanMasterCreateRequest): Promise<TalkPlanMasterCreateResponse> => {
  try {
    const response = await apiClient.post<TalkPlanMasterCreateResponse>('/external/talk_plan_masters/', data);
    return response.data;
  } catch (error) {
    console.error('対話プラン作成エラー:', error);
    throw error;
  }
};
/**
 * 対話プランマスターを更新
 */
export const updateTalkPlanMaster = async(id: number, data: TalkPlanMasterUpdateRequest): Promise<TalkPlanMasterUpdateResponse> => {
  try {
    const response = await apiClient.put<TalkPlanMasterUpdateResponse>(`/external/talk_plan_masters/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error('対話プラン更新エラー:', error);
    throw error;
  }
};
